<template>
  <div>
    <a-card
      style="border: none; border-radius: 12px"
      title="管理员参数配置页面"
    >
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="提示：">
          <a-alert style='margin-bottom: 10px;'
            message="局域网项目必须输入二级域名和authtoken，否则 二维码扫码后无法获取信息，二级域名和authtoken不清楚请联系技术"
            banner
          />
          <a-alert
            message="二级域名和authtoken访问地址：https://natapp.cn/tunnel/lists"
            banner
          />
        </a-form-model-item>
        <a-form-model-item ref="value1" label="二级域名" prop="value1">
          <a-input
            size="large"
            v-model="form.value1"
            placeholder="请输入natapp的二级域名地址"
            suffix="PS:越短越好" 
          />
        </a-form-model-item>
        <a-form-model-item ref="value3" label="authtoken" prop="value3">
          <a-input
            size="large"
            v-model="form.value3"
            placeholder="请输入natapp的authtoken"
          />
        </a-form-model-item>
        <a-form-model-item
          ref="value2"
          label="二维码分享地址前缀"
          prop="value2"
        >
          <a-input
            size="large"
            v-model="form.value2"
            placeholder="请输入二维码分享地址前缀"
          />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 8, offset: 4 }">
          <a-button type="primary" @click="onSubmit"> 保存 </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </div>
</template>

<script>
import instance from "@/request/request";
export default {
  data() {
    return {
      labelCol: { xl: 4 },
      wrapperCol: { xl: 8 },
      form: {
        value1: "", //二级域名
        value2: "", //二维码分享地址
        value3: "", //natapp的authtoken
      },
      rules: {
        value1: {
          required: false,
          message: "请输入natapp的二级域名地址",
          trigger: "change",
        },
        value2: {
          required: true,
          message: "请输入二维码分享地址前缀",
          trigger: "change",
        },
        value3: {
          required: false,
          message: "请输入natapp的authtoken",
          trigger: "change",
        },
      },
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      instance.get("/admin/system").then((res) => {
        console.log("res", res);
        this.form.value1 = res.data.value1 || "";
        this.form.value2 = res.data.value2 || "";
        this.form.value3 = res.data.value3 || "";
      });
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          instance.post("/admin/systemSet", this.form).then((res) => {
            console.log("res", res);
            this.$message.success("保存成功");
            this.getInfo();
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style>
</style>